export default __webpack_public_path__ + "static/media/img_distribution-graph02-m.8a9976d9.png";